import axios from "axios";

// Cuando REACT_APP_BACKEND_URL está vacío o no definido (build para
// Hostinger), usamos rutas relativas → el server.js Express hará proxy a
// /api/*. En Emergent preview la variable sí está definida y apunta al
// preview URL. En ambos casos las requests llegan al backend correcto sin
// depender de un dominio hardcodeado en el bundle.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const client = axios.create({ baseURL: API, timeout: 20000 });

export const fetchStations = async () => (await client.get("/stations")).data;
export const fetchDashboard = async () => (await client.get("/dashboard")).data;
export const fetchRecommendations = async () => (await client.get("/recommendations")).data;
export const fetchStationSnapshot = async (id) =>
  (await client.get(`/stations/${id}/snapshot`)).data;
export const fetchMascotInfo = async () => (await client.get("/mascot")).data;

export const mascotUrl = (variant) => `${API}/mascot/img/${variant}`;
